import ApiBase from './apibase';

class Preferencias extends ApiBase {
  constructor(config, target = undefined) {
    super('personalizacion', config, target);
  }

  /**
   * Sigue un preferible
   * @param {Number} preferibleId - Id del preferible a seguir
   * @param {Number} preferibleTipoId - Id del tipo de preferible a seguir (6:autor, 7:tag, 20:categoria)
   */
  seguirPreferible(preferibleId, preferibleTipoId) {
    const params = {};
    params.preferibleId = preferibleId;
    params.preferibleTipoId = preferibleTipoId;
    return this.addTask('personalizacion', 'json', [
      {
        name: 'suscribir',
        params
      }
    ]);
  }

  /**
   * Obtiene el hash de las suscripciones del usuario. devuelve null si el usuario no tiene suscripciones.
   */
  obtenerHashSuscripciones() {
    const params = {};
    return this.addTask('personalizacion', 'json', [
      {
        name: 'obtener_hash_suscripciones',
        params
      }
    ]);
  }

  /**
   * Deja de seguir un preferible
   * @param {Number} preferibleId - Id del preferible a dejar de seguir
   * @param {Number} preferibleTipoId - Id del tipo de preferible a seguir (6:autor, 7:tag, 20:categoria)
   */
  dejarDeSeguirPreferible(preferibleId, preferibleTipoId) {
    const params = {};
    params.preferibleId = preferibleId;
    params.preferibleTipoId = preferibleTipoId;
    return this.addTask('personalizacion', 'json', [
      {
        name: 'cancelar_suscripcion',
        params
      }
    ]);
  }

  /**
   * Registrar accion sobre contenido
   * @param {Number} contenidoId - Id del contenido
   * @param {Number} contenidoTipoId - Id del tipo de contenido (1:nota)
   * @param {String} [accion] - acción a entrenar
   */
  registrarAccion(contenidoId, contenidoTipoId, accion = 'lectura') {
    return this.addTask('personalizacion', 'json', [
      {
        name: 'registrar_accion',
        params: [contenidoId, contenidoTipoId, accion]
      }
    ]);
  }

  /**
   * Obtiene la cantidad de novedades del usuario
   */
  obtenerNovedades() {
    return this.addTask('personalizacion', 'json', [
      {
        name: 'obtener_cantidad_novedades'
      }
    ]);
  }

  /**
   * Obtiene los preferibles del usuario
   * @param {Number} [preferibleTipoId] - tipo de preferible (6:autor, 7:tag, 20:categoria)
   */
  obtenerPreferibles(preferibleTipoId = null) {
    const params = {};
    params.preferibleTipoId = preferibleTipoId;
    return this.addTask('personalizacion', 'json', [
      {
        name: 'obtener_preferibles',
        params
      }
    ]);
  }

  /**
 * Obtiene notas en base a las preferencias del usuario
 * @param {Number} [cantidad=10] - Cantidad máxima de Notas a devolver
 * @param {Number} [page=1] - Página
 */
  obtener(cantidad, page = 1) {
    const params = {};

    params.quantity = cantidad <= 0 ? 10 : cantidad;
    params.page = page;

    return this.addTask('personalizacion', 'json', [
      {
        name: 'obtener_preferencias',
        params
      }
    ]);
  }
}

export default Preferencias;



// WEBPACK FOOTER //
// ./~/@ln/personalizacion/preferencias.js